// filepath: /src/components/MaintenanceOverlay.js
import React from 'react';
import './MaintenanceOverlay.css';

const MaintenanceOverlay = ({ isActive = true }) => {
  if (!isActive) return null;

  return (
    <div className="maintenance-overlay">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
            <path d="M12 22L13.09 15.74L20 15L13.09 14.26L12 8L10.91 14.26L4 15L10.91 15.74L12 22Z" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
          </svg>
        </div>
        <h2 className="maintenance-title">Próximamente</h2>
        <p className="maintenance-message">
          Estamos preparando algo increíble para ti.<br />
          ¡Vuelve pronto para descubrir las novedades!
        </p>
        <div className="maintenance-spinner">
          <div className="spinner"></div>
        </div>
        <p className="maintenance-contact">
          ¿Tienes alguna pregunta?<br />
          Contáctanos: <a href="mailto:info@thinkhealth.mx">info@thinkhealth.mx</a>
        </p>
      </div>
    </div>
  );
};

export default MaintenanceOverlay;
